var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Chi tiết phiếu bé ngoan",
            visible: _vm.isOpenDetailTicketAppDialog,
            width: "1000px",
            "before-close": _vm.closeDialog,
            "close-on-click-modal": false,
            top: "3vh",
            border: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isOpenDetailTicketAppDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "detailTicketData",
              attrs: {
                "label-width": "140px",
                model: _vm.detailTicketData,
                "label-position": "left",
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c(
                      "div",
                      { staticClass: "grid-content" },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "Tên phiếu bé ngoan",
                              prop: "nameTicket",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                readonly: "",
                                placeholder: "Nhập tên template",
                              },
                              model: {
                                value: _vm.detailTicketData.nameTicket,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.detailTicketData,
                                    "nameTicket",
                                    $$v
                                  )
                                },
                                expression: "detailTicketData.nameTicket",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c(
                      "div",
                      { staticClass: "grid-content" },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "Mô tả",
                              prop: "descriptionTicket",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                readonly: "",
                                placeholder: "Nhập mô tả",
                              },
                              model: {
                                value: _vm.detailTicketData.descriptionTicket,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.detailTicketData,
                                    "descriptionTicket",
                                    $$v
                                  )
                                },
                                expression:
                                  "detailTicketData.descriptionTicket",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c(
                      "div",
                      { staticClass: "grid-content" },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "Tên trường", prop: "nameSchool" },
                          },
                          [
                            _c("h4", { staticClass: "school_name" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.detailTicketData.nameSchool) +
                                  "\n              "
                              ),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-wrap": "wrap",
                    width: "100%",
                    "margin-top": "10px",
                    border: "1px solid rgb(96 99 102 / 19%)",
                    "overflow-y": "scroll",
                    "max-height": "600px",
                    "padding-left": "50px",
                    "min-height": "334px",
                  },
                },
                _vm._l(_vm.listTicket, function (item) {
                  return _c(
                    "div",
                    {
                      key: item.id,
                      staticStyle: {
                        flex: "0 0 223px",
                        margin: "30px",
                        width: "223px",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "inline-block-div" },
                        [
                          _c("el-image", {
                            staticStyle: { width: "250px", height: "200px" },
                            attrs: { src: item.url },
                            on: {
                              click: function ($event) {
                                return _vm.showListImageTicket(item)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      item.numberPicture !== 0
                        ? _c("div", [
                            _c(
                              "h4",
                              {
                                staticStyle: {
                                  color: "#30313499",
                                  "text-align": "left",
                                  "margin-left": "5px",
                                  overflow: "hidden",
                                  "max-height": "20px",
                                  "text-overflow": "ellipsis",
                                  "white-space": "nowrap",
                                },
                              },
                              [_vm._v(_vm._s(item.name))]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "demonstration",
                                staticStyle: {
                                  "margin-right": "5px",
                                  float: "left",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(item.numberPicture) +
                                    "\n              "
                                ),
                                _c("i", {
                                  staticClass: "el-icon-picture",
                                  staticStyle: { color: "#6298d0" },
                                }),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ]
                  )
                }),
                0
              ),
              _c(
                "div",
                { staticClass: "tab-infor-button" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger", size: "medium" },
                      on: {
                        click: function ($event) {
                          return _vm.closeDialogByButton("detailTicketData")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-circle-close" }),
                      _c("span", [_vm._v("Đóng")]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        [
          _c("DetailTicketDialog", {
            attrs: {
              showDetailTicket: _vm.showDetailTicket,
              titleTicket: _vm.titleTicket,
              listTicketDetail: _vm.listTicketDetail,
            },
            on: { close: _vm.handelCloseDetailTicketDialog },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }